




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ReadingTask1 extends Vue {}
